// // import axios from "axios";
// // import { BaseURL } from "../utils/baseURL";
// // import apiClient from "../utils/apiClient";


// // export const fetchTreeData = async () => {
// //   const token = sessionStorage.getItem("accessToken");
// //   const cachedData = sessionStorage.getItem('treeData');
  
// //   if (cachedData) {
// //     return JSON.parse(cachedData);  
// //   }
// //   try {
// //      const response = await apiClient.get("/surveys/tree-surveys/", {
    
// //       headers: {
// //         Authorization: `Bearer ${token}`,
// //         Accept: "application/json",
// //       },
// //     });

// //    if (response.data.status === "success") {
// //       const data = response.data.data.results || []; // Extract results array
// //       sessionStorage.setItem(JSON.stringify(data));
// //       return data;
// //     }

// //     console.error("Failed to fetch tree data.");
// //     return [];  
// //   } catch (error) {
// //     console.error("Error fetching tree data:", error);
// //     return [];  
// //   }
// // };


// // src/assets/data.js
// import apiClient from "../utils/apiClient";

// export const fetchTreeData = async () => {
//   const token = sessionStorage.getItem("accessToken");
//   const cachedData = sessionStorage.getItem("treeData");

//   // Check if cached data exists and is valid
//   if (cachedData) {
//     try {
//       return JSON.parse(cachedData);
//     } catch (error) {
//       console.error("Error parsing cached tree data:", error);
//       sessionStorage.removeItem("treeData"); // Clear invalid cache
//     }
//   }

//   try {
//     const response = await apiClient.get("/surveys/tree-surveys/", {
//       headers: {
//         Authorization: `Bearer ${token}`,
//         Accept: "application/json",
//       },
//     });

//     if (response.data.status === "success") {
//       const rawData = response.data.data || [];
//       // Transform data to match expected GeoJSON-like format
//       const transformedData = rawData.map((tree) => ({
//         geometry: {
//           type: tree.location.type,
//           coordinates: [
//             tree.location.coordinates[1], // Swap to [lat, lng]
//             tree.location.coordinates[0],
//           ], // Assuming backend sends [lng, lat]
//         },
//         properties: {
//           tid: tree.tid,
//           survey_type: tree.survey_type || "in_situ", // Default to 'in_situ' if missing
//           species_name: tree.species_name,
//           project_name: tree.project_name,
//           health_status: tree.health_status,
//           // Add other fields as needed
//           id: tree.id,
//           project_code: tree.project_code,
//           species_name_marathi: tree.species_name_marathi,
//           species_scientific_name: tree.species_scientific_name,
//           ownership: tree.ownership,
//           height: tree.height,
//           girth: tree.girth,
//           diameter_cm: tree.diameter_cm,
//           canopy_diameter: tree.canopy_diameter,
//           estimated_age: tree.estimated_age,
//           tree_age_group: tree.tree_age_group,
//           site_quality: tree.site_quality,
//           damage_severity: tree.damage_severity,
//           created_by_name: tree.created_by_name,
//           created_at: tree.created_at,
//           updated_at: tree.updated_at,
//           thumbnail: tree.thumbnail?.url,
//         },
//       }));
//       // Store transformed data in sessionStorage
//       sessionStorage.setItem("treeData", JSON.stringify(transformedData));
//       console.log("Transformed tree data:", transformedData); // Debug log
//       return transformedData;
//     } else {
//       console.error("Failed to fetch tree data:", response.data.message);
//       return [];
//     }
//   } catch (error) {
//     console.error("Error fetching tree data:", error);
//     return [];
//   }
// };
import apiClient from "../utils/apiClient";
import { BaseURL } from "../utils/baseURL";

export const fetchTreeData = async () => {
  const token = sessionStorage.getItem("accessToken");
  const cachedData = sessionStorage.getItem("treeData");

  // Check if cached data exists and is valid
  if (cachedData) {
    try {
      return JSON.parse(cachedData);
    } catch (error) {
      console.error("Error parsing cached tree data:", error);
      sessionStorage.removeItem("treeData");
    }
  }

  try {
    const response = await apiClient.get("/surveys/tree-surveys/", {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });

    if (response.data.status === "success") {
      const rawData = response.data.data || [];
      // Transform data to match GeoJSON-like format and normalize coordinates
      const transformedData = rawData.map((tree) => {
        let lng = tree.location.coordinates[0];
        let lat = tree.location.coordinates[1];
        // Normalize coordinates: if lng > 90 or lat > 90, assume [lat, lng] order
        if (lng > 90 || lat > 90) {
          [lng, lat] = [lat, lng];
        }
        return {
          geometry: {
            type: tree.location.type,
            coordinates: [lat, lng], // Leaflet expects [lat, lng]
          },
          properties: {
            tid: tree.tid,
            species_name: tree.species_name,
            species_name_marathi: tree.species_name_marathi,
            species_scientific_name: tree.species_scientific_name,
            project_name: tree.project_name,
            project_code: tree.project_code,
            ownership: tree.ownership,
            height: tree.height,
            girth: tree.girth,
            diameter_cm: tree.diameter_cm,
            canopy_diameter: tree.canopy_diameter,
            estimated_age: tree.estimated_age,
            tree_age_group: tree.tree_age_group,
            health_status: tree.health_status,
            site_quality: tree.site_quality,
            damage_severity: tree.damage_severity,
            created_by_name: tree.created_by_name,
            created_at: tree.created_at,
            updated_at: tree.updated_at,
            thumbnail: tree.thumbnail?.url?.startsWith("http")
              ? tree.thumbnail.url
              : `${BaseURL}${tree.thumbnail?.url || ""}`,
          },
        };
      });
      sessionStorage.setItem("treeData", JSON.stringify(transformedData));
      console.log("Transformed tree data:", transformedData);
      return transformedData;
    } else {
      console.error("Failed to fetch tree data:", response.data.data);
      return [];
    }
  } catch (error) {
    console.error("Error fetching tree data:", error);
    return [];
  }
};